export { default } from "./ForgotPasswordApp";
